<template v-if="editFoodRestrictionMenu.isVisible">
    <div>
        <SwipeModalComponent v-if="editFoodRestrictionMenu.isVisible" @closeMenu="cleanAndClose">
            <div class="content-wrapper">
                <h2 v-text="productName"></h2>

                <div class="week-days" @click="openModal">
                    <h2>Dias da semana</h2>
                    <!-- mostar lista com dias da semana selecionados, separados por vírgula -->
                    <div class="selected-days" v-if="selectedDays.length > 0">
                        <span>
                            {{ daysString }}
                            <i class="fa fa-magnifying-glass fa-xs"></i>
                        </span>
                    </div>
                    <div v-else>
                        <span>
                            Nenhum dia selecionado
                            <i class="fa fa-magnifying-glass fa-xs"></i>
                        </span>
                    </div>
                </div>

                <div class="proibir">
                    <input type="checkbox" id="cantConsume" v-model="cantConsume" />
                    <label for="cantConsume">Proibir Consumo</label>
                </div>

                <div class="limit" v-if="!cantConsume">
                    <h1>Limite de consumo diário</h1>
                    <div class="edit-limit">
                        <div class="button" @click="decreaseLimit">
                            <i class="fa fa-minus"></i>
                        </div>
                        <input type="text" v-model="limit" />
                        <div class="button" @click="increaseLimit">
                            <i class="fa fa-plus"></i>
                        </div>
                    </div>
                </div>

                <div class="buttons">
                    <button class="delete fa fa-trash fa-2xl" @click="openDeleteModal"></button>
                    <button class="confirm" @click="updateRestriction">Confirmar</button>
                </div>
            </div>

        </SwipeModalComponent>
        <WeekDaysModalEdit label="Dias da Semana" :initialDays="selectedDays" @closeModal="closeModalE" :isOpen="modalEOpen" />

        <ModalInfoDel @actionTrue="emitDeletion" @actionFalse="modalDeleteOpen = false" :modalOpen="modalDeleteOpen" />
    </div>
</template>
<script >
import SwipeModalComponent from './SwipeModalComponent.vue'
import WeekDaysModalEdit from '@/components/modals/WeekDaysModal.vue'
import ModalInfoDel from '@/components/modals/ModalInfo.vue'
import { mapGetters, mapActions } from 'vuex'

export default {
    name: 'EditFoodLimitComponent',
    props: ['productName', 'productLimit', 'productCantConsume', 'productWeekDays'],
    emits: ['closeMenu', 'deleteProduct'],
    components: {
        SwipeModalComponent,
        WeekDaysModalEdit,
        ModalInfoDel
    },
    data () {
        return {
            cantConsume: false,
            limit: 0,
            selectedDays: [],
            daysString: '',
            modalEOpen: false,
            modalDeleteOpen: false
        }
    },
    computed: {
        ...mapGetters(['editFoodRestrictionMenu'])
    },
    methods: {
        ...mapActions(['changeEditRestrictionMenuVisibility', 'changeWeekDaysModalVisibility', 'showModalInfo', 'closeModalInfo']),
        increaseLimit: function () {
            this.limit++
        },
        decreaseLimit: function () {
            if (this.limit > 0) {
                this.limit--
                if (this.limit === 0) {
                    this.cantConsume = true
                }
            }
        },
        openDeleteModal: function () {
            this.modalDeleteOpen = true
            this.showModalInfo({ type: 'defaultDialog', text: 'Deseja deletar o produto', icon: 'fa-solid fa-trash' })
        },
        emitDeletion: function () {
            this.modalDeleteOpen = false
            this.$emit('deleteProduct')
        },
        cleanAndClose () {
            this.selectedDays = this.convertDays(this.productWeekDays)
            this.changeEditRestrictionMenuVisibility()
        },
        openModal () {
            this.modalEOpen = true
        },
        closeModalE (days) {
            this.modalEOpen = false
            this.selectedDays = days
        },
        getWeekDays () {
            // retorna os dias selecionados na forma SSSSSSS (S = selected, N = not selected), começando por domingo
            // ex: ['segunda', 'quarta', 'sexta'] => 'NSNSNSN'
            const weekDays = ['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado']
            let weekDaysString = ''
            for (let i = 0; i < weekDays.length; i++) {
                if (this.selectedDays.includes(weekDays[i])) {
                    weekDaysString += 'S'
                } else {
                    weekDaysString += 'N'
                }
            }

            if (weekDaysString === '') {
                weekDaysString = 'NNNNNNN'
            }

            return weekDaysString
        },
        updateRestriction () {
            const weekDays = this.getWeekDays()
            this.$emit('closeMenu', this.limit, weekDays)
            this.changeEditRestrictionMenuVisibility()
        },
        convertDays (days) {
            const weekDays = ['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado']
            const selectedDays = []
            for (let i = 0; i < weekDays.length; i++) {
                if (days[i] === 'S') {
                    selectedDays.push(weekDays[i])
                }
            }
            return selectedDays
        }
    },
    watch: {
        productLimit (val) {
            this.limit = val
        },
        productCantConsume (val) {
            this.cantConsume = val
        },
        selectedDays (val) {
            if (val.length === 0) {
                this.daysString = 'Nenhum dia selecionado'
                return false
            }
            this.daysString = val.join(', ')
        },
        productWeekDays (val) {
            this.selectedDays = []
            this.selectedDays = this.convertDays(val)
            this.daysString = this.selectedDays.join(', ')
        }
    },
    mounted () {
    }
}
</script>

<style lang="less" scoped>

.content-wrapper {
    max-width: 100%;

        h2 {
            text-align: center;

            &:last-of-type {
                margin-bottom: 40px;
            }
        }

        .week-days {
            margin-bottom: 30px;
            h2 {
                margin-bottom: 10px;
                text-align: left;
            }

            div {
                display: flex;
                justify-content: space-between;
                align-items: center;
                flex-wrap: wrap;

                span {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    border: solid #BAB8B8 2px;
                    border-radius: 5px;
                    padding: 5px 10px;
                    width: 100%;
                }
            }
        }

        .proibir {
            border-bottom: solid #BAB8B8 2px;
            padding-bottom: 20px;

            input {
              accent-color: var(--buttonBackground);
            }
        }

        // h1 na esquerda e os botões e o limite na direita
        .limit {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin: 20px 0;
            padding-bottom: 20px;
            border-bottom: solid #BAB8B8 2px;

            h1 {
                // 2 linhas
                max-width: 50%;
            }

            .edit-limit {
                display: flex;
                justify-content: space-between;
                align-items: center;
                width: 100px;

                .button {
                    width: 30px;
                    height: 30px;
                    border-radius: 50%;
                    background: var(--iconColor);
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    i {
                        color: var(--buttonText);
                    }
                }

                input {
                    margin: 0 5px;
                    background-color: var(--backgroundColor);
                    color: var(--textColor);
                    width: 30px;
                    height: 30px;
                    border: none;
                    font-size: 18px;
                    font-family: Gellix;
                    text-align: center;
                }
            }
        }

        .buttons {
            width: 100%;
            display: flex;
            justify-content: space-between;
            margin-bottom: 20px;
            margin-top: 20px;

            .confirm {
              color: var(--buttonText);
              background-color: var(--buttonBackground);
            }
        }

        button {
            color: var(--iconColor);
            border-radius: 5px;
            padding: 10px;
            margin: 0;
            border: none;
            background-color: transparent;
        }
    &.opened {
        transform: translateY(0);
        display: block;
    }
}</style>
